import React, { useState, useEffect } from 'react'
import Dashboard from './Dashboard'
import Projection from './Projection'
import AggregatorMain from './Aggregators/Main'
import LeadReversalSystem from './LeadReversalSystem'
import LiveReportMain from './LiveReports/Main'
import CampaginsDash from './CampaginsDash'
import Event from './Event'
import moment from 'moment'
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';
export default function MainContent({
  activeSubTab,
  activeTab,
  handleBack
}) {
  const dispatch = useDispatch();
  const { fromDate, toDate } = useSelector(state => state.FilterReduce.commonFilters);
  const [commonFilter, setCommonfilter] = useState({
    fromDate: fromDate, toDate: toDate
  })

  useEffect(() => {
    setCommonfilter({
      fromDate: fromDate, toDate: toDate
    })
      
      }, [fromDate, toDate]);

  const handleFilter = (type, value) => {
    dispatch({ type: FILTER_ACTION, payload: { [type]: value } });
    setCommonfilter((prev) => ({
      ...prev,
      [type]: value
    }))
  }

  return (
    <>
      {
        activeTab == "dashboard" ? <Dashboard handleBack={handleBack} handleFilter={handleFilter} commonFilter={commonFilter} /> : ""
      }
      {
        activeTab == "liveReports" ? <LiveReportMain handleFilter={handleFilter} commonFilter={commonFilter} /> : ""
      }
      {
        activeTab == "projections" ? <Projection handleBack={handleBack} handleFilter={handleFilter} commonFilter={commonFilter} /> : ""
      }
      {
        activeTab == "aggregators" ? <AggregatorMain handleBack={handleBack} handleFilter={handleFilter} commonFilter={commonFilter} /> : ""
      }
      {
        activeTab == "events" ? <Event handleBack={handleBack} handleFilter={handleFilter} commonFilter={commonFilter} /> : ""
      }
      {
        activeTab == "reverseLead" ? <LeadReversalSystem /> : ""
      }
      {
        activeTab == "Campaigns" ? <CampaginsDash  handleBack={handleBack} /> : ""
      }

    </>
  )
}
